// extracted by mini-css-extract-plugin
module.exports = {"container_inner":"_3ea6fa5da8--container_inner--kcp_K","container-mobile_inner":"_3ea6fa5da8--container-mobile_inner--wF5_l","text":"_3ea6fa5da8--text--hwoPp"};